import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewSteps: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTradingViewSteps"><Path d="M4.5 7.49997V16.5M9.5 3.5V12.5M14.5 11.5V20.5M19.5 7.5V16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTradingViewSteps;
